import { Chip, styled, TextField } from '@mui/material';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { ArrayItem } from './styles';


const StyledTextField = styled(TextField)`
  font-size: 14px;
  & .MuiOutlinedInput-input {
    font-size: 14px;
  }
`;

const ArrayField = ({ field, value, onChange }) => {
  const [input, setInput] = useState('');

  const deleteItem = (itemToDelete) => {
    onChange(field, value.filter((item) => item !== itemToDelete));
  };

  const addItem = () => {
    if (value.some((item) => item === input)) {
      toast.error(`${input} already exists in ${field} array`);
      return;
    }
    onChange(field, [...value, input]);
    setInput('');
  };

  return (
    <>
      <ArrayItem>
        {value.map((item) => (
          <Chip
            key={item}
            label={item}
            variant="outlined"
            onDelete={() => deleteItem(item)}
            size="small"
            sx={{
              fontSize: 'clamp(10px,0.5vw,16px)',
              '& .MuiChip-label': {
                textTransform: 'none',
              },
            }}
          />
        ))}
      </ArrayItem>
      <StyledTextField
        type="text"
        disabled={false}
        id="article-tags"
        variant="outlined"
        value={input}
        placeholder="Enter field name"
        onKeyDown={(e) => (e.key === 'Enter' ? addItem() : null)}
        onChange={(e) => setInput(e.target.value)}
        size="small"
      />
    </>
  );
};

export default ArrayField;
